import React, {useState, useEffect, useRef} from 'react';
import DatePicker from "react-datepicker";
import {findPdvSalesByStatus} from "../../utils/requestUtils";
import {useRecoilState} from "recoil";
import {loadingAtom} from "../../atoms";
import {formatDateTimeString} from "../../utils/utils";
import 'react-datepicker/dist/react-datepicker.css';
import eyeIcon from '../../img/icons8-eye-24.png';
import PdvSaleManagerSeeItems from "./PdvSaleManagerSeeItems";

const PdvSalesList = () => {
    const [sales, setSales] = useState([]);
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [queryString, setQueryString] = useState('');
    const [status, setStatus] = useState(1);
    const [, setLoading] = useRecoilState(loadingAtom);
    const [totalValue, setTotalValue] = useState(0);
    const [seeItems, setSeeItems] = useState(false);
    const [currentSeeSale, setCurrentSeeSale] = useState(undefined);

    const userStr = localStorage.getItem('user') || sessionStorage.getItem('user') || '{}';
    let isAdmin = false;
    try { const u = JSON.parse(userStr); isAdmin = u.adminUser === true; } catch (_) {}

    async function makeQuery() {
        try {
            setLoading(true);
            const newStartDate = startDate || new Date(1900, 0, 1);
            const newEndDate = endDate || new Date(2100, 0, 1);
            let data = await findPdvSalesByStatus(newStartDate, newEndDate, status) || [];
            if (queryString?.trim()) {
                const q = queryString.trim();
                data = data.filter(s =>
                    s.id === Number(q) ||
                    s.customerName?.toUpperCase().includes(q) ||
                    s.customer?.name.toUpperCase().includes(q) ||
                    s.table?.name.toUpperCase().includes(q)
                );
            }
            const total = data.reduce((acc, sale) =>
                acc + (sale.saleItems || []).reduce((a2, item) => a2 + (item.total || 0), 0), 0);
            setTotalValue(total);
            setSales(data);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => { makeQuery(); }, []);

    function removeSpecialChars(str) {
        return str.normalize("NFD").replace(/[̀-ͯ]/g, "").toLowerCase();
    }

    const handleInputChange = (e) => {
        setQueryString(removeSpecialChars(e.target.value).toUpperCase());
    };

    function isSameDay(a, b) {
        return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
    }

    function getSaleDateDisplay(saleDate) {
        const today = new Date();
        const isTodayRange = startDate && endDate && isSameDay(startDate, today) && isSameDay(endDate, today);
        const formatted = formatDateTimeString(saleDate);
        return isTodayRange ? formatted.split(' ')[1] : formatted;
    }

    function getDateColumnHeader() {
        const today = new Date();
        return startDate && endDate && isSameDay(startDate, today) && isSameDay(endDate, today) ? 'Hora' : 'Data';
    }

    return seeItems ? (
        <PdvSaleManagerSeeItems sale={currentSeeSale} isAdmin={isAdmin}
            onClose={() => setSeeItems(false)} onRemove={makeQuery}/>
    ) : (
        <>
            <div className="header-label">Consultar Pedidos</div>
            <div style={{marginTop: '5px'}}>
                <div style={{marginTop: '5px', display: 'flex', alignItems: 'center'}}>
                    <DatePicker className="datepicker" selected={startDate}
                        onChange={setStartDate} isClearable dateFormat="dd/MM/yyyy"/>
                    até
                    <DatePicker className="datepicker" selected={endDate}
                        onChange={setEndDate} dateFormat="dd/MM/yyyy" isClearable/>
                </div>
                <div style={{marginTop: '5px', display: 'flex', alignItems: 'center'}}>
                    <input style={{width: '100%'}} type="text" value={queryString} onChange={handleInputChange}/>
                </div>
                <div style={{marginTop: '5px', display: 'flex', alignItems: 'center'}}>
                    <select style={{flexGrow: 1}} value={status} onChange={(e) => setStatus(parseInt(e.target.value))}>
                        <option value={-1}>Todos</option>
                        <option value={1}>Pendentes</option>
                        <option value={2}>Pagos</option>
                    </select>
                    <button onClick={makeQuery}>Consultar</button>
                </div>
            </div>
            <div style={{flexGrow: 1, overflowY: 'auto'}}>
                <table style={{width: '100%'}}>
                    <colgroup>
                        <col style={{width: '200px'}}/>
                        <col style={{width: '120px'}}/>
                        <col style={{width: '120px'}}/>
                        <col style={{width: '150px'}}/>
                        <col style={{width: '150px'}}/>
                    </colgroup>
                    <thead>
                    <tr>
                        <th>Cliente</th>
                        <th>Mesa</th>
                        <th>Garçom</th>
                        <th>{getDateColumnHeader()}</th>
                        <th/>
                    </tr>
                    </thead>
                    <tbody>
                    {sales.map((sale, index) => (
                        <tr key={index} style={{height: '41px'}}>
                            <td><div>{sale.customer ? sale.customer.name : sale.customerName}</div></td>
                            <td><div>{sale.table ? sale.table.name : ''}</div></td>
                            <td><div>{sale.user ? sale.user.name : ''}</div></td>
                            <td><div>{getSaleDateDisplay(sale.saleDate)}</div></td>
                            <td>
                                <button onClick={() => { setSeeItems(true); setCurrentSeeSale(sale); }}
                                        style={{padding: '5px 5px 0px 5px'}}>
                                    <img src={eyeIcon} alt="Ver" style={{width: '20px', height: '20px'}}/>
                                </button>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                    {sales.length === 0 && <tfoot><tr><td colSpan={5}>Nenhum item encontrado</td></tr></tfoot>}
                </table>
            </div>
            {isAdmin && (
                <div style={{marginTop: '5px'}}>
                    <div className="total-label" style={{textAlign: 'right'}}>
                        Valor Total: R$ {totalValue.toLocaleString('pt-BR', {minimumFractionDigits: 2, maximumFractionDigits: 2})}
                    </div>
                </div>
            )}
        </>
    );
};

export default PdvSalesList;
